import { useState, useCallback } from 'react';

/**
 * 防双击保护Hook
 * 功能：防止用户多次点击导致重复操作，提供操作保护机制
 * 参数：delay - 保护延迟时间（毫秒），默认5000ms
 * 返回值：{ isProtected, protect, release }
 * 修改时间：2025.10.19
 * 修改内容：为协作库操作添加防多次点击保护，解决createTopicModalData为null的问题
 * 使用场景：协作库主题创建、删除等关键操作
 */
export const useDoubleClickProtection = (delay = 5000) => {
  const [isProtected, setIsProtected] = useState(false);

  const protect = useCallback(() => {
    if (isProtected) {
      return false; // 如果已经在保护状态，返回false表示不允许操作
    }
    
    setIsProtected(true);
    
    // 设置定时器，在指定时间后自动释放保护
    setTimeout(() => {
      setIsProtected(false);
    }, delay);
    
    return true; // 返回true表示允许操作
  }, [isProtected, delay]);

  const release = useCallback(() => {
    setIsProtected(false);
  }, []);

  return {
    isProtected,
    protect,
    release
  };
};

export default useDoubleClickProtection;
